/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

import styled from "styled-components";

const Vienna = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.5579 0.514594V11.4866C7.23205 11.5796 6.89425 11.6441 6.54736 11.6774V0.323846C6.89425 0.357098 7.23205 0.42163 7.5579 0.514594Z"
      fill="currentColor"
    />
    <path
      d="M10.6737 6.00062C10.6737 4.36297 9.83657 2.92095 8.56843 2.08233V0.911754C10.4172 1.85287 11.6842 3.7783 11.6842 6.00062C11.6842 8.22294 10.4172 10.1484 8.56843 11.0895V9.9331H8.54683C9.82705 9.09662 10.6737 7.64754 10.6737 6.00062Z"
      fill="currentColor"
    />
    <path
      d="M4.52632 0.491275C4.85252 0.403667 5.19029 0.344444 5.53684 0.316406V11.6848C5.19029 11.6568 4.85252 11.5976 4.52631 11.51C2.10143 10.8587 0.315796 8.63887 0.315796 6.00062C0.315796 3.74471 1.62136 1.79475 3.5158 0.869766V2.02795C2.20064 2.85768 1.32632 4.32695 1.32632 6.00062C1.32632 8.07352 2.6675 9.83287 4.52631 10.452L4.52632 0.491275Z"
      fill="currentColor"
    />
    <path d="M6.7158 5.37081H11.2632V6.38465H6.7158V5.37081Z" fill="currentColor" />
  </svg>
);

export const ViennaBadge = () => {
  return (
    <StyledBadge>
      <SVGCenterWrapper>
        <Vienna />
      </SVGCenterWrapper>
    </StyledBadge>
  );
};

export const UrbitTilde = () => {
  return (
    <svg width="8" height="4" viewBox="0 0 8 4" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.53516 0.85053H6.13912C6.03401 1.46848 5.76381 1.84208 5.28344 1.84208C4.41279 1.84208 3.91745 0.821777 2.56644 0.821777C1.26043 0.821777 0.569897 1.62656 0.464844 3.16417H1.86088C1.96599 2.53185 2.23619 2.15824 2.73153 2.15824C3.60218 2.15824 4.06752 3.17855 5.44859 3.17855C6.72454 3.17855 7.4301 2.37377 7.53516 0.85053Z"
        fill="black"
      />
    </svg>
  );
};

export const UrbitBadge = () => {
  return (
    <StyledBadge>
      <SVGCenterWrapper>
        <UrbitTilde />
      </SVGCenterWrapper>
    </StyledBadge>
  );
};

const StyledBadge = styled.div`
  margin-left: 4px;
  display: inline-block;
  height: 16px;
  width: 16px;
  border: ${({ theme }) => `1px solid ${theme.primary}`};
  color: ${({ theme }) => theme.primary};
`;

const SVGCenterWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
